import React from "react";

import { DownNavAltIcon } from "@/components/icons/DownNavAltIcon";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { AtcOption } from "@/types/atc";
import { cn, getOldPrice, getPrice } from "@/utils/general";

import styles from "./HeaderStickyDropdown.module.scss";

interface HeaderStickyDropdownOptionProps {
  option: AtcOption;
  index: number;
  type: "normal" | "float";
  selectedOptionId?: number;
  onSelect: (e: React.MouseEvent) => void;
}

const getTitle = (option: AtcOption) => {
  if (option?.ui_data?.stickyHeaderTitle) {
    return option.ui_data.stickyHeaderTitle;
  }

  return option?.ui_data?.title === "Single Bottle" ? "One-Time Purchase" : option?.ui_data?.title;
};

const HeaderStickyDropdownOption: React.FC<HeaderStickyDropdownOptionProps> = ({
  option,
  index,
  type,
  selectedOptionId,
  onSelect,
}) => {
  if (!option) {
    return null;
  }

  const newPrice = getPrice(option);
  const oldPrice = getOldPrice(option);

  return (
    <button
      key={index}
      id={index.toString()}
      className={cn(
        styles.optionWrap,
        styles[type],
        {
          [styles.active]: selectedOptionId === index,
        },
        `header-atc-option-${index}`
      )}
      onClick={onSelect}
      aria-label={getTitle(option)}
    >
      <div className="flex">
        <div className="w-full">
          <TextElementNova
            element="span"
            text={getTitle(option)}
            className="Body-10-Dia-Strong text-left w-full pl-4"
          />
        </div>
        <div className="flex w-[40%] justify-end">
          {oldPrice && oldPrice > newPrice ? (
            <div className="pr-[4px]">
              <TextElementNova
                element="span"
                aria-label={`Was ${oldPrice} dollars, now discounted`}
                text={`$${oldPrice}`}
                className="Body-10-Dia-Normal text-nova-transparency-black-60 line-through"
              />
            </div>
          ) : null}

          <div>
            <TextElementNova element="span" text={`$${newPrice}`} className="Body-10-Dia-Strong" />
          </div>
          <div>
            <DownNavAltIcon
              className={`plus-icon transform rotate-180 text-nova-base-black ${type === "normal" ? "w-[42px]" : "invisible w-[16px]"}`}
            />
          </div>
        </div>
      </div>
    </button>
  );
};

export default HeaderStickyDropdownOption;
